import { PATH_SIGNUP_ME_GET_STARTED } from '@farmersdog/constants/paths';
import { useLocation } from 'react-router-dom';

interface UseIsOnGetStartedCardArgs {
  isTOSA: boolean;
}
export function useIsOnGetStartedCard({ isTOSA }: UseIsOnGetStartedCardArgs) {
  const { pathname } = useLocation();

  if (!isTOSA) {
    return false;
  }

  return pathname.includes(PATH_SIGNUP_ME_GET_STARTED);
}
